import { render, staticRenderFns } from "./CoverageSimple.vue?vue&type=template&id=2bfaf43d&"
import script from "./CoverageSimple.vue?vue&type=script&lang=js&"
export * from "./CoverageSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports